import type { IWorkingHours } from '@interfaces/IWorkingHours';

/** Rest-day weekday numbers (0=Sun … 6=Sat) derived from a site's working-hours.
 *  `days` is Monday-indexed (index 0 = Mon); a weekday is a rest day iff its
 *  dailyWorkerHours is 0. Returns an EMPTY set when the calendar is unknown
 *  (available:false) — callers then treat every day as a working day. */
export function restDaysFromWorkingHours(wh: IWorkingHours): Set<number> {
  const rest = new Set<number>();
  if (!wh.available) return rest;
  wh.days.forEach((d, i) => {
    if (d.dailyWorkerHours === 0) rest.add((i + 1) % 7); // Mon(0)→getUTCDay 1 … Sun(6)→0
  });
  return rest;
}

const weekday = (iso: string) => new Date(`${iso}T00:00:00Z`).getUTCDay();

export function isRestDay(iso: string, restDays: Set<number>): boolean {
  return restDays.has(weekday(iso));
}

export function isWorkingDay(iso: string, restDays: Set<number>): boolean {
  return !restDays.has(weekday(iso));
}
